import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		background: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			zIndex: -1,
			maxWidth: '100%',
			overflow: 'hidden',
			backgroundPositionY: ({ metaData }) => metaData.backgroundImagePosition?.metaValue || 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			'&:after': {
				content: '""',
				transition: theme.transitions.create('opacity'),
				backgroundColor: 'black',
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: 0,
				left: 0,
				opacity: ({ metaData, isMobile }) =>
					(isMobile ? metaData.mobileOpacity?.toNumber() : metaData.opacity?.toNumber() || 0) / 100,
			},
		},
		content: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '100%',
		},
		paper: {
			maxWidth: theme.spacing(56),
		},
		form: {
			padding: theme.spacing(4, 2.5, 3.5),
			[theme.breakpoints.up('md')]: {
				padding: theme.spacing(4),
			},
		},

		mobileImageWrapper: {
			marginLeft: theme.spacing(-2),
			marginRight: theme.spacing(-2),
			transition: theme.transitions.create(['margin-top', 'margin-bottom']),
			marginTop: ({ metaData }) => {
				if (!metaData.mobileImagePosition?.isRightAlignment) return null

				return theme.spacing(3)
			},
			marginBottom: ({ metaData }) => {
				if (!metaData.mobileImagePosition?.isLeftAlignment) return null

				return theme.spacing(3)
			},
		},

		mobileImage: {
			width: '100%',

			'& picture': {
				width: '100%',
			},
			'& img': {
				width: '100%',
				objectFit: 'contain',
			},
		},
	}),
	{ name: 'Forms-5' },
)

export default useStyles
